import { render, staticRenderFns } from "./PromoCategoryAssign.vue?vue&type=template&id=bf7a1c0e&scoped=true&"
import script from "./PromoCategoryAssign.vue?vue&type=script&lang=js&"
export * from "./PromoCategoryAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7a1c0e",
  null
  
)

export default component.exports